<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-12" type="autocomplete" label="Пакет"
        v-model="packageID" @change="onPackageSearch" :items="packagesForSelect"
        placeholder="Введите 3 символа для поиска" autocompleteDisplay="name"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'AddUserToEvent',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
  },
  props: {
    participant: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      packageID: undefined,
      packagesForSelect: [],
      amount: 1,
    }
  },
  computed: {
    ...mapState('events', ['event']),
    autocompleteLink() {
      return `/v1/events/${this.event.id}/packages/available/list`;
    },
  },
  methods: {
    ...mapActions('packages', ['addPackageToParticipant']),
    async onPackageSearch(text) {
      [this.packagesForSelect] = await this.getAutocompleteData(this.autocompleteLink, text);
    },
    async submit() {
      try {
        await this.addPackageToParticipant({
          participantID: this.$props.participant.id,
          packageID: this.packageID,
          amount: this.amount,
        });
        this.$toasted.success('Пакет выдан');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.button--add {
  margin-top: 22px;
}
</style>